export default "__VITE_ASSET__DLTQ14Gn__"